import { get } from "../../pwa/ajax";
import * as BucketTools from "../common/bucket";

const sitioId = window.config.Sitio.Id;
const urlApiRoot = window.config.Statics.ApiContenidoUrlRoot;
const urlRankingSitio = urlApiRoot + window.config.Statics.ApiRankingSitioUrl;
const bucket = window.config.Statics.BucketUrl;

export const getHomeRanking = () => {
    get(urlRankingSitio + sitioId)
        .then(rs => renderHomeRanking(JSON.parse(rs)));
}

const renderHomeRanking = (data) => {
    const notas = data.items.slice(0, 5);
    const articleMasLeidas = document.querySelector("#masLeidasSitio.mas-leidas");
    let imgUrl;
    
    let html = `<div class="techo-2 floatFix">
                    <span class="titulo-destacado" >
                        lo más visto <b>ahora</b>
                    </span>
                </div>`;
    let toi = 401;
    for (let nota of notas) {
        let toiPos = "toi".concat(toi.toString());
        let img = "";
        if (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
            imgUrl = `${BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, "70")}`;
            img = `<img src="${imgUrl}"/>`;
        }
        html += `<article class="noticia foto floatFix" data-id="${nota.id}" data-notaid="${nota.id}" data-source="ranking" data-pos="${toiPos}">
                    <a class="figure" href="/${nota.url}">
                        ${img}
                    </a>    
                    <h2>
                        <a href="/${nota.url}">
                            ${nota.titulo}
                        </a>
                    </h2>   
                </article>`;
        toi++;
    }
    articleMasLeidas.innerHTML = html;
}


// WEBPACK FOOTER //
// ./Statics/scripts/home/masLeidas.js